import gql from 'graphql-tag';

export const UPDATE_VENUE = gql`
  mutation UpdateVenue($input: UpdateVenueInput!) {
    updateVenue(input: $input) {
      success
      error
      venue {
        id
        name
        phone
        street
        street2
        city
        state
        zip
        description
        timeZone
        stripeAccountType
        interactiveMaps
        interactiveMapsForRenters
        textMessageIndicator
        showAssignments
        allowCardReaderPayments
        stripeLocation
        requiredMapAssignmentsForRenters
        extraChargesEnabled
        discountCodesEnabled
        discountCodesForRenters
        stripeAccount
        feePerProduct
        percentageFee
        feeCap
        includeStripeFee
        applyPlatformFeeOnZeroDollarOrder
        minPlatformFee
        platformFee
        requiredQuestionsForAdmins
        venueConfig {
          accountingReport
          reconReport
          requiredAddons
          includePastEvents
          defermentEmailsEnabled
        }
      }
    }
  }
`;
